import {useEffect, useState} from "react";
import {IYear} from "../../utils/interfaces/IYear";
import PeriodsList from "./PeriodsList";
import {useAccounting} from "../../utils/contexts/accounting_context";
import {csvHeaders, invoice_csv_data} from "../../logics/csv-export";
import {CSVLink} from "react-csv";
import {PiCheckFatFill, PiFileCsv} from "react-icons/pi";
import {RiCheckboxBlankCircleFill, RiCheckFill} from "react-icons/ri";


interface YearRowProps {
    obj: IYear,
}

function YearRow({obj: initialObj}: YearRowProps) {
    const {selectedYear, selectYear, selectPeriod} = useAccounting()
    const [obj, setObj] = useState<IYear>(initialObj)

    const csv_data = (year: IYear) => {
        const transformedData: Array<Record<string, any>> = [];
        const periods = year.periods;
        periods.forEach((period) => {
            const invoices = period.invoices;
            invoices.forEach((invoice) => {
                const invoiceData = invoice_csv_data(invoice);
                invoiceData.forEach((record) => {
                    record.year = year.year;
                    record.month = period.month;
                });
                transformedData.push(...invoiceData);
            });
        });

        return transformedData;
    };


    const handleSelect = (obj: IYear) => {
        if (selectedYear === obj) {
            selectYear(undefined)
        } else {
            selectYear(obj);
            selectPeriod(undefined)
        }

    }

    useEffect(() => {
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj])


    return (
        <>
            <div className="flex flex-row items-stretch mb-1.5">
                <button
                    className="mycia_accounting_button"
                    key={obj.year}
                    onClick={() => handleSelect(obj)}
                >
                    {obj.year}
                </button>
                <div>

                    <div className="flex flex-row">

                        <div className="totals_div">
                            <div className="content-container">
                                <label>Prenotazioni</label>
                                <div className="text_span">
                                    {obj.totals.bookings.annual_count.toFixed(0)}
                                </div>
                            </div>
                        </div>

                        <div className="totals_div">
                            <div className="content-container">
                                <label>Coperti</label>
                                <div className="text_span">
                                    {obj.totals.bookings.annual_seats.toFixed(0)}
                                </div>
                            </div>
                        </div>

                        <div className="totals_div">
                            <div className="content-container">
                                <label>Imponibile</label>
                                <div className="text_span">
                                    {obj.totals.bookings.annual_nett_price.toFixed(2) + ' €'}
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="flex flex-row">

                        <div className="totals_div">
                            <div className="content-container">
                                <label>Ordini</label>
                                <div className="text_span">
                                    {obj.totals.transactions.annual_count.toFixed(0)}
                                </div>
                            </div>
                        </div>

                        <div className="totals_div">
                            <div className="content-container">
                                <label>Imponibile</label>
                                <div className="text_span">
                                    {obj.totals.transactions.annual_amount.toFixed(2) + ' €'}
                                </div>
                            </div>
                        </div>

                        <div className="totals_div">
                            <div className="content-container">
                                <label>Mycia Commission</label>
                                <div className="text_span">
                                    {obj.totals.transactions.annual_mycia_commission.toFixed(2) + ' €'}
                                </div>
                            </div>
                        </div>

                        <div className="totals_div">
                            <div className="content-container">
                                <label>Stripe Commission</label>
                                <div className="text_span">
                                    {obj.totals.transactions.annual_stripe_commission.toFixed(2) + ' €'}
                                </div>
                            </div>
                        </div>

                        <div className="totals_div">
                            <div className="content-container">
                                <label>Commission</label>
                                <div className="text_span">
                                    {obj.totals.transactions.annual_commission.toFixed(2) + ' €'}
                                </div>
                            </div>
                        </div>

                        <div className="totals_div">
                            <div className="content-container">
                                <label>Saldo</label>
                                <div className="text_span">
                                    {obj.totals.transactions.annual_balance && obj.totals.transactions.annual_balance.toFixed(2)} €
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="flex flex-row">
                        <div className="cisco_totals_div">
                            <div className="content-container">
                                <label>Studio Cisco:</label>
                            </div>
                        </div>

                        <div className="cisco_totals_div">
                            <div className="content-container">
                                <label>Imponibile Prenotazioni</label>
                                <div className="text_span">
                                    {obj.totals.bookings.annual_nett_price.toFixed(2) + ' €'}
                                </div>
                            </div>
                        </div>

                        <div className="cisco_totals_div">
                            <div className="content-container">
                                <label>Imponibile Rebounds</label>
                                <div className="text_span">
                                    {obj.totals.rebounds.annual_to_invoice_amount.toFixed(2) + ' €'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="cisco_totals_div ml-0.5">
                    <label>Imponibile Fatturato</label>
                    <div className="text_span ">
                        {obj.totals.monthly_invoices.annual_total_invoiced.toFixed(2)}
                    </div>
                    {
                        (obj.totals.monthly_invoices.annual_total_invoiced === obj.totals.monthly_invoices.annual_total_to_invoice) ?
                            (<RiCheckboxBlankCircleFill className='mt-1'/>)
                            :
                            (<PiCheckFatFill className='mt-1'
                                             color={obj.totals.monthly_invoices.annual_total_invoiced === 0 ? 'transparent' : ''}/>)
                    }
                </div>
                <div
                    className="cisco_totals_div ml-0.5">
                    <label>Imponibile da Fatturare</label>
                    <div className="text_span">
                        {obj.totals.monthly_invoices.annual_total_to_invoice.toFixed(2)}
                    </div>
                    <RiCheckboxBlankCircleFill className='mt-1 text-transparent'/>
                </div>
                <button
                    className="bg-mcia_orange hover:bg-mcia_salmon text-white font-bold py-2 px-4 rounded mb-0.5  shadow-xl ml-0.5">
                    <CSVLink
                        data={csv_data(obj)}
                        headers={csvHeaders}
                        filename="exported-data.csv"
                        separator=";"
                        className="d-flex align-items-center justify-content-center" // Center the content
                        target="_blank"
                    >
                        <PiFileCsv style={{fontSize: '36px'}}/> {/* Enlarge the icon */}
                    </CSVLink>
                </button>
            </div>

            {(selectedYear?.year === obj.year) ? (
                <PeriodsList obj={obj}/>
            ) : (
                ''
            )}
        </>
    )
}

export default YearRow;